<template>
  <div>
    <el-breadcrumb separator="/" style="padding-bottom: 10px;">
      <el-breadcrumb-item>首页</el-breadcrumb-item>
      <el-breadcrumb-item>订单管理</el-breadcrumb-item>
      <el-breadcrumb-item>订单列表</el-breadcrumb-item>
    </el-breadcrumb>

    <div class="table">
      <div class="top">
        <div class="top-query">
          <el-form ref="queryData" :model="queryData" label-width="100px" size="mini">
            <el-form-item label="产品名称" style="width: 520px;">
              <el-input placeholder="请输入产品名称" v-model="queryData.productName"></el-input>
            </el-form-item>
            <el-form-item label="影院名称" style="width: 520px;">
              <el-input placeholder="影院名称" v-model="queryData.company"></el-input>
            </el-form-item>
            <el-form-item label="订单状态">
              <el-radio-group v-model="queryData.orderState">
                <el-radio :label="100">待审核</el-radio>
                <el-radio :label="101">IMAX已审核</el-radio>
                <el-radio :label="102">已支付</el-radio>
                <el-radio :label="209">开始生产</el-radio>
                <el-radio :label="210">已发货</el-radio>
                <el-radio :label="212">已付款,支付已确认</el-radio>
                <el-radio :label="211">已开票</el-radio>
                <!--                <el-radio :label="104">确认收款</el-radio>-->
              </el-radio-group>
            </el-form-item>
            <el-form-item label="下单时间">
              <el-date-picker v-model="queryData.data" style="width:420px" type="daterange"
                              :default-time="['00:00:00', '23:59:59']"
                              value-format="yyyy-MM-dd HH:mm:ss" align="right"
                              unlink-panels range-separator="至" start-placeholder="开始日期"
                              end-placeholder="结束时间">
              </el-date-picker>
            </el-form-item>
            <el-form-item style="float: right;">
              <el-button type="primary" @click="onSubmit">查询</el-button>
              <el-button @click="reset">重置</el-button>
            </el-form-item>
          </el-form>
          <div v-if="statisticsStatus=='true'" style="margin: 10px 30px;"><span>下单数：</span>
            <span
                id="orders">{{ orderData.orders }}</span>
            <span> 张</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span>总金额：</span>
            <span
                id="amount">{{ orderData.amount }}</span>
            <span> ¥</span></div>
        </div>

        <div>
          <el-upload
              class="upload-demo"
              action="/movie/v2/order/import/excel"
              :show-file-list="false"
              :on-success="(response) => importExcell(response)"
              style="float:left; padding-right: 10px;"
          >
            <el-button  type="success" size="mini" icon="el-icon-folder-add"
                        v-if="orderExportStatus=='true' && (userType==3 || userType==4)">导入快递信息</el-button>
          </el-upload>

          <el-button type="info" @click="exportOrder" size="mini" icon="el-icon-folder-opened"
                     v-if="orderExportStatus=='true' && (userType==3 || userType==4)">导出生产
          </el-button>

          <el-button type="primary" @click="exportOrderInvoice" size="mini" icon="el-icon-folder-opened"
                     v-if="orderExportStatus=='true' && (userType==3 || userType==4)">导出支付待开票
          </el-button>

          <el-button type="warning" size="mini" icon="el-icon-finished" v-if = "userType==2 || userType==4" @click="doExamine1()">批量审核</el-button>

          <el-button type="success" @click="exportAllOrder" size="mini" icon="el-icon-folder-opened"
                     v-if="orderExportStatus=='true' && (userType==5 || userType==4)" plain>导出
          </el-button>
        </div>
      </div>

      <!-- 列表数据 -->
      <div class="content">
        <el-table  border :data="tableData" style="width: 100%;z-index: 0;"
                   :show-header="true"
                   @selection-change = "selectionChange">
          <!--          <el-table-column type="selection" :selectable="selectable" :reserve-selection="true" min-width="5%;"  v-if = "userType==3">-->
          <!--          </el-table-column>-->

          <!-- 勾选框列 -->
          <el-table-column
              type="selection"
              width="55"
              :selectable="selectable"
          ></el-table-column>

          <!-- 展开行 -->
          <el-table-column  border type="expand">
            <template slot-scope="props">
              <!-- 子表格，显示商品详情 -->
              <el-table :data="props.row.orderdetails" style="width: 100%">
                <el-table-column label="序号" width="50px">
                  <template slot-scope="scope">
                    {{ scope.$index + 1 }}
                  </template>
                </el-table-column>

                <el-table-column label="商品图片" width="100">
                  <template slot-scope="scope">
                    <ImageCarousel :images="scope.row.imageUrls.split(',')"
                                   :show-index="false"
                                   :buttonVisible="false"
                                   class="product-image" style="width: 100px; height: 100px;" />
                  </template>
                </el-table-column>

                <!--                <el-table-column label="商品ID" prop="productId"></el-table-column>-->
                <el-table-column label="产品名称" prop="productName" :show-overflow-tooltip="false"></el-table-column>
                <!--                <el-table-column label="产品尺寸" prop="dimension" show-overflow-tooltip></el-table-column>-->
                <!--                <el-table-column label="产品材质" prop="material" show-overflow-tooltip></el-table-column>-->
                <!--                <el-table-column label="产品描述" prop="productDescribe" show-overflow-tooltip></el-table-column>-->
                <el-table-column label="产品类型" prop="productType"></el-table-column>
                <el-table-column label="购买数量" prop="orderCount">
                  <template slot-scope="scope">
                    {{scope.row.orderCount}} 件
                  </template>
                </el-table-column>
                <el-table-column label="限购情况" >
                  <template slot-scope="scope">
                    {{scope.row.orderMinNumber}} 件 -> {{scope.row.orderMaxNumber}} 件
                  </template>
                </el-table-column>

                <el-table-column label="单价" prop="productPrice">
                  <template slot-scope="scope">
                    {{scope.row.productPrice}} ￥
                  </template>
                </el-table-column>

                <el-table-column label="合计金额" prop="amount">
                  <template slot-scope="scope">
                    {{scope.row.amount}} ￥
                  </template>
                </el-table-column>

                <el-table-column label="快递地址" prop="address" :show-overflow-tooltip="false"></el-table-column>
                <el-table-column label="快递收件人" prop="addressName"></el-table-column>
                <el-table-column label="快递联系方式" prop="addressPhone"></el-table-column>

                <el-table-column label="快递公司" prop="expressCompany" show-overflow-tooltip></el-table-column>
                <el-table-column label="快递单号" prop="expressNo" :show-overflow-tooltip="false"></el-table-column>

              </el-table>
            </template>
          </el-table-column>

          <!-- 主表格的列 -->
          <el-table-column label="订单ID" prop="orderId" min-width="10%;"></el-table-column>
          <el-table-column label="影院名称" prop="company" min-width="20%;"></el-table-column>
          <el-table-column label="订单金额" prop="orderAmount" min-width="10%;">
            <template slot-scope="scope">
              {{scope.row.orderAmount}} ￥
            </template>
          </el-table-column>
          <el-table-column label="订单状态" prop="orderStateStr" min-width="10%;"></el-table-column>
          <el-table-column label="下单时间" prop="createTime" min-width="10%;"></el-table-column>
          <el-table-column label="审核时间" prop="orderExamineTime" min-width="10%;"></el-table-column>
          <!--          <el-table-column label="快递时间" prop="orderExpressTime" min-width="10%;"></el-table-column>-->
          <el-table-column label="支付时间" prop="payTime" min-width="10%;"></el-table-column>
          <el-table-column label="开票时间" prop="orderExpressTime" min-width="10%;"></el-table-column>

          <el-table-column label="合同信息" min-width="10%;">
            <template slot-scope="scope">
              <el-button type="info" size="mini"  @click="openPreview(scope.row.contractUrl)" plain>查看合同</el-button>
              <!--              <div class="thumbnail" @click="openPreview(scope.row.contractUrl)">-->
              <!--                <embed-->
              <!--                    :src="scope.row.contractUrl"-->
              <!--                    :width="thumbnailWidth"-->
              <!--                    :height="thumbnailHeight"-->
              <!--                    alt="pdf文件预览"-->
              <!--                />-->
              <!--              </div>-->
            </template>
          </el-table-column>

          <el-table-column label="沟通凭证" min-width="10%;">
            <template slot-scope="scope">
              <div v-if="scope.row.createOrderImages.length > 0">
                <ImageCarousel :images="scope.row.createOrderImages"
                               :show-navigation="true"
                               :show-delete="orderUpdateStatus=='true' && (userType==1 || userType==2 || userType==4) && scope.row.orderState==100"
                               :show-index="false"
                               @delete-image="(index) => deleteImageFile(index, scope.row.orderId, '100')"
                               class="product-image" style="width: 100px; height: 100px;" />
              </div>

              <div v-if="scope.row.createOrderImages.length <= 0">
                <el-upload
                    class="upload-demo"
                    action="/movie/v1/file/upload"
                    :before-upload="beforeUpload"
                    :on-success="(response, file, fileList) => handleRowCreateSuccess(response, scope.row)"
                    :on-remove="handleRowCreateRemoveRowPreview"
                    :file-list="rowCreateOrderFile"
                    :show-file-list="false"
                >
                  <el-button size="mini" type="success" v-if="orderUpdateStatus=='true' && (userType==1 || userType==2 || userType==4) && scope.row.orderState==100" >点击上传</el-button>
                </el-upload>

                <div v-if="scope.row.rowCreateOrderImages && scope.row.rowCreateOrderImages.length">
                  <ul>
                    <li v-for="(image, index) in scope.row.rowCreateOrderImages" :key="index" style="display: inline-block; margin: 10px;">
                      <img :src="image" alt="uploaded image" style="width: 100px; height: 100px; object-fit: cover;">
                      <el-button size="mini" type="danger" icon="el-icon-delete" @click="handleRowCreateRemoveRowPreview(scope.row, index)" circle></el-button>
                    </li>
                    <el-button size="mini" type="primary" @click="doCreate(scope.row)" round>提交</el-button>
                  </ul>
                </div>

              </div>
            </template>
          </el-table-column>

          <el-table-column label="支付凭证" min-width="10%;">
            <template slot-scope="scope">
              <div v-if="scope.row.payOrderImages.length > 0">
                <ImageCarousel :images="scope.row.payOrderImages"
                               :show-navigation="true"
                               :show-delete="orderUpdateStatus=='true' && (userType==1 || userType==2 || userType==4) && (scope.row.orderState==101 || scope.row.orderState==102)"
                               :show-index="false"
                               @delete-image="(index) => deleteImageFile(index, scope.row.orderId, '102')"
                               class="product-image" style=" width: 100px; height: 100px;"/>
              </div>

              <div v-if="scope.row.payOrderImages.length <= 0">
                <el-upload
                    class="upload-demo"
                    action="/movie/v1/file/upload"
                    :before-upload="beforeUpload"
                    :on-success="(response, file, fileList) => handleRowPaySuccess(response, scope.row)"
                    :on-remove="handleRowPayRemove"
                    :file-list="rowPayOrderFile"
                    :show-file-list="false"
                >
                  <el-button size="mini" type="success" v-if="userType!=3 && (scope.row.orderState==101 || scope.row.orderState==102)" >点击上传</el-button>
                </el-upload>

                <div v-if="scope.row.rowPayOrderImages && scope.row.rowPayOrderImages.length">
                  <ul>
                    <li v-for="(image, index) in scope.row.rowPayOrderImages" :key="index" style="display: inline-block; margin: 10px;">
                      <img :src="image" alt="uploaded image" style="width: 100px; height: 100px; object-fit: cover;">
                      <el-button size="mini" type="danger" icon="el-icon-delete" @click="handleRowPayRemoveRowPreview(scope.row, index)" circle></el-button>
                    </li>
                    <el-button size="mini" type="primary" @click="doPay(scope.row)" round>提交</el-button>
                  </ul>
                </div>
              </div>

            </template>
          </el-table-column>

          <el-table-column label="发票" min-width="10%;">
            <template slot-scope="scope">
              <div v-if="scope.row.invoiceImages.length > 0">
                <ImageCarousel :images="scope.row.invoiceImages"
                               :show-navigation="true"
                               :show-delete="orderUpdateStatus=='true' && (userType==3 || userType==4 || userType==5) && (scope.row.orderState==101 || scope.row.orderState==102) "
                               :show-index="false"
                               @delete-image="(index) => deleteImageFile(index, scope.row.orderId, '211')"
                               class="product-image" style=" width: 100px; height: 100px;"/>
              </div>

              <div v-if="scope.row.invoiceImages.length <= 0">
                <el-upload
                    class="upload-demo"
                    action="/movie/v1/file/upload"
                    :before-upload="beforeUpload"
                    :on-success="(response, file, fileList) => handleRowInvoiceSuccess(response, scope.row)"
                    :on-remove="handleRowInvoiceRemove"
                    :file-list="rowInvoiceOrderFile"
                    :show-file-list="false"
                >
                  <el-button size="mini" type="success" v-if="(userType==3 || userType==4 || userType==5) && (scope.row.orderState==101 || scope.row.orderState==102)" plain>点击上传</el-button>
                </el-upload>

                <div v-if="scope.row.rowInvoiceOrderImages && scope.row.rowInvoiceOrderImages.length">
                  <ul>
                    <li v-for="(image, index) in scope.row.rowInvoiceOrderImages" :key="index" style="display: inline-block; margin: 10px;">
                      <img :src="image" alt="uploaded image" style="width: 100px; height: 100px; object-fit: cover;">
                      <el-button size="mini" type="danger" icon="el-icon-delete" @click="handleRowInvoiceRemoveRowPreview(scope.row, index)" circle></el-button>
                    </li>
                    <el-button size="mini" type="primary" @click="doInvoice(scope.row)" round>提交</el-button>
                  </ul>
                </div>
              </div>
            </template>
          </el-table-column>


          <el-table-column fixed="right" label="操作" min-width="15%;">
            <template slot-scope="scope">

              <el-button circle icon="el-icon-delete" type="danger" size="mini" v-if = "orderUpdateStatus=='true' && (userType==1 || userType==2 || userType==4) && scope.row.orderState==100"  @click="remove(scope.row.orderId)"></el-button>

              <el-button circle icon="el-icon-edit" round type="info" size="mini" v-if = "orderUpdateStatus=='true' && (userType==1 || userType==2 || userType==4) && scope.row.orderState==100"  @click="openDialog(scope.row)"></el-button>

              <el-button round type="primary" size="mini" v-if = "orderUpdateStatus=='true' && (userType==2 || userType==4)"  @click="doExamine(scope.row)">审核</el-button>

              <el-button round type="success" size="mini" v-if = "orderUpdateStatus=='true' && (userType==5 || userType==4) && scope.row.orderState==102"  @click="doConfirm(scope.row)">确认已支付</el-button>

              <el-button round type="warning" size="mini" v-if = "orderUpdateStatus=='true' && (userType==5 || userType==4) && scope.row.orderState==212"  @click="doCancelConfirm(scope.row)">撤销支付确认</el-button>

              <el-button round type="danger" size="mini" v-if = "orderUpdateStatus=='true' && (userType==2 || userType==4)
              && (scope.row.orderState==210 || scope.row.orderState==101 || scope.row.orderState==211) && (scope.row.rowPayOrderImages == undefined || scope.row.payOrderImages <= 0)"  @click="doDemandPayment(scope.row)">催款</el-button>

            </template>
          </el-table-column>
        </el-table>

      </div>
      <div class="bottom">
        <el-pagination @size-change="handleSizeChange" @current-change="changePage"
                       :current-page="queryData.pageNo"
                       :page-sizes="[15, 25, 40, 50]" :page-size="queryData.size"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="total" style="float: right;">
        </el-pagination>
      </div>
    </div>


    <!-- 弹窗展示PDF文件 -->
    <el-dialog
        title="PDF文件预览"
        :visible.sync="dialogPdfVisible"
        :width="dialogWidth"
        @close="resetPreview"
    >
      <div class="pdf-preview-container">
        <embed :src="contractUrl" :width="dialogWidth" :height="dialogHeight" />
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogPdfVisible = false">关闭</el-button>
      </span>
    </el-dialog>

    <!-- 弹窗 -->
    <el-dialog
        title="订单详情"
        ref="orderDialog"
        :visible.sync="orderDetailsVisible"
        width="80%"
        @close="resetTableData"
    >
      <!-- 弹窗内容：表格和新增行按钮 -->
      <!--      <el-button @click="addRow" type="primary" style="margin-bottom: 10px;">新增行</el-button>-->

      <p style="margin-bottom: 10px; font-size: 15px" >影院名称： {{cinema}} </p>

      <el-table :data="OrderDetailsList" style="width: 100%" border>

        <el-table-column label="商品图片" width="100">
          <template slot-scope="scope">
            <ImageCarousel :images="scope.row.imageUrls.split(',')" :buttonVisible="false" class="product-image" style="width: 100px; height: 100px;" />
          </template>
        </el-table-column>

        <el-table-column label="产品名" prop="productName" show-overflow-tooltip>
        </el-table-column>

        <el-table-column label="产品类型" prop="productType">
        </el-table-column>

        <el-table-column label="工艺描述" prop="productDescribe" show-overflow-tooltip>
        </el-table-column>

        <el-table-column label="产品材质" prop="material" show-overflow-tooltip>
        </el-table-column>

        <el-table-column label="产品尺寸" prop="dimension" show-overflow-tooltip>
        </el-table-column>

        <el-table-column label="限购情况" >
          <template slot-scope="scope">
            {{scope.row.orderMinNumber}} 件 -> {{scope.row.orderMaxNumber}} 件
          </template>
        </el-table-column>

        <el-table-column label="购买数量" prop="orderCount">
          <template slot-scope="scope">
            <el-input-number v-model="scope.row.orderCount" size="small"></el-input-number>
          </template>
        </el-table-column>

        <el-table-column label="金额" prop="amount">
          <template slot-scope="scope">
            {{scope.row.amount}} ￥
          </template>
        </el-table-column>

        <el-table-column label="下单地址" prop="address">
          <!--          <template slot-scope="scope">-->
          <!--            <el-select v-model="scope.row.addressId" placeholder="请选择" size="small"-->
          <!--                       @change="handleSelectChange(scope.row, $event)">-->
          <!--              <el-option-->
          <!--                  v-for="item in addressOptions"-->
          <!--                  :key="item.value"-->
          <!--                  :label="item.label"-->
          <!--                  :value="item.value">-->
          <!--              </el-option>-->
          <!--            </el-select>-->
          <!--          </template>-->
        </el-table-column>

        <el-table-column label="收件人" prop="addressName">
          <!--          <template slot-scope="scope">-->
          <!--            <el-input readonly  v-model="scope.row.addressName" size="small"></el-input>-->
          <!--          </template>-->
        </el-table-column>

        <el-table-column label="收件人电话" prop="addressPhone">
          <!--          <template slot-scope="scope">-->
          <!--            <el-input readonly  v-model="scope.row.addressPhone" size="small"></el-input>-->
          <!--          </template>-->
        </el-table-column>

      </el-table>

      <!-- 弹窗底部按钮 -->
      <div slot="footer" class="dialog-footer">
        <el-button @click="orderDetailsVisible = false">关闭</el-button>
        <el-button type="primary" @click="saveData">保存</el-button>
      </div>
    </el-dialog>

    <!-- 审核弹窗 -->
    <el-dialog
        title="审核"
        :visible.sync="dialogExamineVisible"
        width="400px"
        @close="resetForm"
    >
      <el-input v-show="false" :value="examineOrderId" disabled></el-input>

      <el-radio-group v-model="approvalStatus">
        <el-radio label="approved">通过</el-radio>
        <el-radio label="rejected">拒绝</el-radio>
        <el-radio label="refund">退款</el-radio>
      </el-radio-group>

      <!-- 如果选择了拒绝，显示原因输入框 -->
      <div v-if="approvalStatus === 'rejected' || approvalStatus === 'refund'">
        <el-input
            v-model="rejectionReason"
            type="textarea"
            placeholder="请输入拒绝\退款原因"
            rows="4"
        ></el-input>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogExamineVisible = false">取消</el-button>
        <el-button type="primary" @click="submitAudit">确认</el-button>
      </span>
    </el-dialog>

    <!-- 批量审核弹窗 -->
    <el-dialog
        title="审核"
        :visible.sync="dialogExamineVisible1"
        width="400px"
        @close="resetForm"
    >
      <!--      <el-input v-show="false" :value="examineOrderId" disabled></el-input>-->

      <el-radio-group v-model="approvalStatus">
        <el-radio label="approved">通过</el-radio>
        <el-radio label="rejected">拒绝</el-radio>
        <el-radio label="refund">退款</el-radio>
      </el-radio-group>

      <!-- 如果选择了拒绝，显示原因输入框 -->
      <div v-if="approvalStatus === 'rejected'">
        <el-input
            v-model="rejectionReason"
            type="textarea"
            placeholder="请输入拒绝原因"
            rows="4"
        ></el-input>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogExamineVisible1 = false">取消</el-button>
        <el-button type="primary" @click="batchChange">确认</el-button>
      </span>
    </el-dialog>

    <el-dialog
        title="编辑"
        :visible.sync="dialogVisible"
        width="50%">
      <span>
        <el-form ref="formValidate" :model="order" size="mini" label-width="150px" class="demo-ruleForm"
                 :rules="ruleValidate">
          <el-form-item label="订单Id" prop="orderId" style="width: 85%">
            <el-input v-model="order.orderId" disabled></el-input>
          </el-form-item>
          <el-form-item label="产品名称" prop="productName" style="width: 85%">
            <el-input v-model="order.productName" disabled></el-input>
          </el-form-item>
          <el-form-item label="产品规格" prop="productSpecs" style="width: 85%">
            <el-input v-model="order.productSpecs" disabled></el-input>
          </el-form-item>
          <el-form-item label="产品数量" prop="productNums" style="width: 85%">
            <el-input v-model="order.productNums" placeholder="请输入产品数量" type='number'></el-input>
          </el-form-item>
           <el-form-item label="用户地址">
              <Select v-model="order.addressId" style="width:80%" placeholder="请选择用户地址">
                    <Option v-for="item in order.addressList" :value="item.id"
                            :key="item.id">{{ item.phone + "," + item.address }}</Option>
              </Select>
            </el-form-item>
        </el-form>
      </span>
      <span slot="footer" class="dialog-footer">
    <el-button size="small" @click="dialogVisible = false">取 消</el-button>
    <el-button size="small" type="primary" @click="update('formValidate')">修改</el-button>
  </span>
    </el-dialog>
    <el-dialog
        :title=dialogTitle
        :visible.sync="dialogVisible1"
        width="30%"
    >
      <div class="line"></div>
      <span style="text-align: center;font-size:24px;color:#000" >
        请确认是否审核该订单？
      </span>
      <div class="line1"></div>
      <span slot="footer" class="dialog-footer">
    <el-button size="small" @click="dialogVisible1 = false">取 消</el-button>
    <el-button size="small" type="primary" @click="updateStatus()">确定</el-button>
  </span>
    </el-dialog>

    <el-dialog
        :title=dialogTitle
        :visible.sync="dialogVisible3"
        width="30%">
      <div class="line"></div>
      <span style="text-align: center;font-size:24px;color:#000" >
        请确认是否收款?
      </span>
      <div class="line1"></div>
      <span slot="footer" class="dialog-footer">
    <el-button size="small" @click="dialogVisible1 = false">取 消</el-button>
    <el-button size="small" type="primary" @click="updateStatus()">确定</el-button>
  </span>
    </el-dialog>
    <el-dialog
        title="删除"
        :visible.sync="dialogVisible2"
        width="30%">
      <div class="line"></div>
          <span style="text-align: center;font-size:24px;color:#000" >
            请确认是否删除?
          </span>
      <div class="line1"></div>
      <span slot="footer" class="dialog-footer">
          <el-button size="small" @click="dialogVisible1 = false">取 消</el-button>
          <el-button size="small" type="primary" @click="delete1">确定</el-button>
      </span>
    </el-dialog>

    <el-dialog
        title="催款通知"
        :visible.sync="dialogPayMentVisible"
        width="30%">
      <div class="line"></div>
      <span style="text-align: center;font-size:24px;color:#000" >
            请确认是否下发催款通知?
          </span>
      <div class="line1"></div>
      <span slot="footer" class="dialog-footer">
          <el-button size="small" @click="dialogPayMentVisible = false">取 消</el-button>
          <el-button size="small" type="primary" @click="demandPayment">确定</el-button>
      </span>
    </el-dialog>


    <!-- 订单详情弹窗 -->
    <!--    <el-dialog title="订单详情" :visible.sync="cartVisible" width="90%">-->
    <!--      <el-card class="box-card">-->
    <!--        <el-table :data="orderDetail.cartItems" style="width: 100%" :show-header="true"  @selection-change="handleSelectionChange">-->
    <!--          &lt;!&ndash; 勾选框列 &ndash;&gt;-->
    <!--          <el-table-column-->
    <!--              type="selection"-->
    <!--              width="55"-->
    <!--              :selectable="selectable"-->
    <!--          ></el-table-column>-->

    <!--          <el-table-column prop="productImageUrl" label="商品图片">-->
    <!--            <template slot-scope="scope">-->
    <!--              <img :src="scope.row.productImageUrl" style="width: 100px; height:100px" alt="Image" />-->
    <!--            </template>-->
    <!--          </el-table-column>-->
    <!--          <el-table-column prop="productName" label="商品"></el-table-column>-->
    <!--          <el-table-column prop="quantity" label="数量">-->
    <!--            <template slot-scope="scope">-->
    <!--              <el-input v-model="scope.row.quantity" style="width: 50%;" ></el-input>个-->
    <!--            </template>-->
    <!--          </el-table-column>-->
    <!--          <el-table-column prop="productType" label="产品类型"></el-table-column>-->
    <!--          <el-table-column prop="expirationDateEnd" label="下单截止时间"></el-table-column>-->
    <!--          <el-table-column prop="orderMinNumber" label="最小起订数"></el-table-column>-->
    <!--          <el-table-column prop="orderMaxNumber" label="最大购买数"></el-table-column>-->
    <!--          <el-table-column prop="productPrice" label="单价">-->
    <!--            <template slot-scope="scope">-->
    <!--              {{scope.row.productPrice}}-->
    <!--              <span>¥</span>-->
    <!--            </template>-->
    <!--          </el-table-column>-->

    <!--          <el-table-column prop="totalAmount" label="总价">-->
    <!--            <template slot-scope="scope">-->
    <!--              {{scope.row.productPrice * scope.row.quantity}}-->
    <!--              <span>¥</span>-->
    <!--            </template>-->
    <!--          </el-table-column>-->
    <!--        </el-table>-->
    <!--        <div style="float: right; height: 40px; padding: 15px 15px;"><span>合计：</span><span>{{this.orderDetail.cartTotal}}</span></div>-->
    <!--      </el-card>-->

    <!--      <el-card class="box-card" style="margin-top: 20px; ">-->
    <!--        <el-form label-width="100px">-->
    <!--          <el-form-item label="地址选择:" prop="productName" style="width: 85%">-->
    <!--            <div class="form-item-content">-->
    <!--              <div class="item">-->
    <!--                <el-select v-model="this.orderDetail.addressValue" placeholder="选择收货地址" @change="handleAddress">-->
    <!--                  <el-option-->
    <!--                      v-for="item in this.orderDetail.addressOptions"-->
    <!--                      :key="item.value"-->
    <!--                      :label="item.label"-->
    <!--                      :value="item.value">-->
    <!--                  </el-option>-->
    <!--                </el-select>-->
    <!--              </div>-->

    <!--              <div class="item">-->
    <!--                <span>地址信息:</span>-->
    <!--                <span>{{this.orderDetail.addressDetails}}</span>-->
    <!--              </div>-->

    <!--              <div class="item">-->
    <!--                <span>联系电话:</span>-->
    <!--                <span>{{this.orderDetail.phoneNumber}}</span>-->
    <!--              </div>-->

    <!--              <div class="item">-->
    <!--                <span>昵称:</span>-->
    <!--                <span>{{this.orderDetail.nikeName}}</span>-->
    <!--              </div>-->
    <!--            </div>-->
    <!--          </el-form-item>-->

    <!--          <el-form-item label="订单名称:" prop="orderName" style="width: 85%">-->
    <!--            <el-input v-model="this.orderDetail.orderName" placeholder="请输入订单名称"></el-input>-->
    <!--          </el-form-item>-->

    <!--          <el-form-item label="交易凭证信息:" prop="" style="width: 85%">-->
    <!--            <el-upload-->
    <!--                ref="cartUpload"-->
    <!--                class="upload-demo"-->
    <!--                action="/movie/v1/file/upload"-->
    <!--                :on-preview="handleCartPreview"-->
    <!--                :on-success = "handleCartSuccess"-->
    <!--                :on-remove="handleCartRemove"-->
    <!--                :file-list="cartData.fileList"-->
    <!--            >-->
    <!--              <el-button size="small" type="primary">点击上传</el-button>-->
    <!--            </el-upload>-->
    <!--          </el-form-item>-->

    <!--          <el-form-item label="凭证预览:" prop="productType" style="width: 85%">-->
    <!--            <div v-if="this.cartDataImageUrls.length > 0">-->
    <!--              <ul>-->
    <!--                <li v-for="(image, index) in this.cartDataImageUrls" :key="index" style="display: inline-block; margin: 10px;">-->
    <!--                  <img :src="image" alt="uploaded image" style="width: 150px; height: 150px; object-fit: cover;">-->
    <!--                  <button type="button" @click="handleRemoveCartPreview(index)" style="display: block;margin-top: 5px;" class="button-del">删除</button>-->
    <!--                </li>-->
    <!--              </ul>-->
    <!--            </div>-->
    <!--          </el-form-item>-->

    <!--        </el-form>-->

    <!--      </el-card>-->

    <!--      <span slot="footer" class="dialog-footer">-->
    <!--            <el-button @click="cartVisible = false">取消</el-button>-->
    <!--            <el-button type="primary" @click="createOrder">结算</el-button>-->
    <!--        </span>-->
    <!--    </el-dialog>-->
    <!--订单详情弹窗 结束... -->

  </div>
</template>
<script>
// import router from "../../router";
import {
  confirmOrder,
  cancelConfirmOrder,

  orderStatistics,
  orderList,
  deleteFileUrl,
  gotoPay,
  gotoInvoice,
  gotoExamine,
  gotoDemandPayment,
  getOrderDetails,
  getAddress,
  updateOrder,
  deleteOrder,
  updateStatusOrder,
  batchChange,
  gotoCreate
} from "../../request/api.js";
// import {path} from "../../request/request";
import axios from "axios";
import ImageCarousel from "@/components/ImageCarousel.vue";
import moment from "moment";
// import PDFPreview from "@/components/PDFPreview.vue";

export default {
  name: "OrderList",
  components: {ImageCarousel},
  data() {
    return {
      total: 1,
      orderId: '',
      tableData: [],
      // orderCreateStatus:window.sessionStorage.getItem('orderCreateStatus'),
      statisticsStatus: window.sessionStorage.getItem("statisticsStatus"),
      orderUpdateStatus: window.sessionStorage.getItem('orderUpdateStatus'),
      orderDeleteStatus: window.sessionStorage.getItem('orderDeleteStatus'),
      orderExportStatus: window.sessionStorage.getItem('orderExportStatus'),
      // showTitle: {
      //   title: '展开',
      //   class: 'el-icon-arrow-down'
      // },
      queryForm: {
        show: false,
      },

      addressOptions:[],
      userAddressList: [],

      queryData: {
        orderState: null, //订单状态
        productName: null,
        orderName: null,
        company: null,
        data: [],
        startTime: "",
        endTime: "",
        pageNo: 1,
        size: 15,
      },


      //pdf
      contractUrl: '',
      dialogPdfVisible:false,
      thumbnailWidth: '150px', // 缩略图的默认宽度
      thumbnailHeight: '100px', // 缩略图的默认高度
      dialogWidth: '80%', // 弹窗显示 PDF 时的宽度
      dialogHeight: '700px', // 弹窗显示 PDF 时的高度

      //列表中的文件上传
      rowCreateOrderFile:[],
      rowCreateOrderImages:[],

      rowPayOrderFile:[],
      rowPayOrderImages:[],

      rowInvoiceOrderFile:[],
      rowInvoiceOrderImages:[],


      OrderDetailsList:[],
      updateOrder:"",
      cinema:"",

      // 审核弹窗
      approvalStatus: 'approved',
      // 拒绝原因
      rejectionReason: '',
      dialogExamineVisible:false,
      dialogExamineVisible1:false,
      dialogPayMentVisible:false,
      examineOrderId:"",

      orderDetailsVisible:false,
      dialogVisible: false,
      dialogVisible1: false,
      dialogVisible2:false,
      dialogVisible3:false,
      content:"",
      dialogTitle:"",
      userType: window.sessionStorage.getItem('userType'),
      multipleSelection:[],
      order: {
        orderId: '',
        productNums: 6,
        products: '',
        addressId: 1,
        amount: "",
        expressFee: "",
        printFee: "",
        inspectFee: "",
        packFee: "",
        accessoriesFee: "",
        manageFee: "",
        serviceFee: "",
        orderAmount: '',
        orderState: '',
        addressList: [],
        productName: '',
        productSpecs: ''
      },
      orderData: {
        orders: 0,
        amount: 0
      },

      orderPayMent: {
        orderId: '',
        userId:''
      },

      orderDetail: {
        cartItems:[],
        cartTotal:"",

        addressOptions:[],
        addressValue:"",

        addressDetails:"",
        phoneNumber:"",
        nikeName:"",

        orderName:"",

      },

      ruleValidate: {
        productNums: [{
          required: true,
          message: '请输入产品数量',
          trigger: 'blur'
        }],
        addressId: [{
          required: true,
          message: '请选择用户地址',
          trigger: 'blur'
        }],
      }

    }


  },
  methods: {
    openPreview(pdfUrl) {
      window.open(pdfUrl);
      // 点击缩略图时打开弹窗
      // this.contractUrl = pdfUrl;
      // this.dialogPdfVisible = true;
    },
    resetPreview() {
      // 关闭弹窗时重置
      this.dialogPdfVisible = false;
      this.contractUrl = ''; // 清空当前 PDF URL
    },
    //todo 以上pdf的操作

    /**
     * 删除图片信息
     * @param imageIndex
     * @param rowData
     */
    deleteImageFile(imageIndex, rowData, params) {
      console.log(">>>>> deleteImageFile:  {}, {}", params, JSON.stringify(rowData));
        this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          var paramData = rowData + '?flowState=' + params;
          deleteFileUrl(paramData).then(resp => {
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
            // 删除成功后刷新数据或执行其他操作
            console.log("resp" + resp);
            this.orderList();
          }).catch(error => {
            this.$message({
              type: 'error',
              message: '删除失败: ' + error.message
            });
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
    },

    /**
     * 处理列表中的支付图片
     * @param row
     * @param index
     */
    handleRowCreateRemoveRowPreview(row, index) {
      // 删除预览图片
      this.rowCreateOrderFile.splice(index, 1);
      row.rowCreateOrderImages.splice(index, 1);
    },

    /**
     * 处理列表中的支付图片
     * @param row
     * @param index
     */
    handleRowPayRemoveRowPreview(row, index) {
      // 删除预览图片
      this.rowPayOrderFile.splice(index, 1);
      row.rowPayOrderImages.splice(index, 1);
    },

    handleRowPayRemove(file, fileList) {
      // 根据文件的 URL 删除相应的图片
      console.log("fileList" + fileList)
      const index = this.scope.row.rowPayOrderImages.indexOf(file.url);
      if (index !== -1) {
        this.scope.row.rowPayOrderImages.splice(index, 1);
      }
    },

    handleRowPaySuccess(response, row) {
      // 确保 rowImageUrls 是数组
      if (!row.rowPayOrderImages) {
        this.$set(row, 'rowPayOrderImages', []);
      }
      // 假设后端返回的图片 URL
      if (response) {
        this.$set(row.rowPayOrderImages, row.rowPayOrderImages.length, response.data.fileUrl);  // 强制 Vue 重新渲染
      }
    },

    handleRowCreateSuccess(response, row) {
      // 确保 rowImageUrls 是数组
      if (!row.rowCreateOrderImages) {
        this.$set(row, 'rowCreateOrderImages', []);
      }
      // 假设后端返回的图片 URL
      if (response) {
        this.$set(row.rowCreateOrderImages, row.rowCreateOrderImages.length, response.data.fileUrl);  // 强制 Vue 重新渲染
      }
    },

    importExcell(response){
      console.log(response.code+","+response);
      if(response.code==20000){
        this.$Message.info("导入成功");
      }
    },

    /**
     * 提交沟通凭证
     */
    doCreate(row) {
      console.log(JSON.stringify(row));
      const param = {
        "orderId": row.orderId,
        "payImageUrls": row.rowCreateOrderImages
      };

      gotoCreate(param).then((data) => {
        console.log(JSON.stringify(data))
        this.$message({
          message: data.msg,
          type: 'success'
        });
        this.orderList();
      });
    },
    /**
     * 去开票
     * @param row
     */
    doPay(row) {
      if (row.rowPayOrderImages == undefined || row.rowPayOrderImages <= 0 ) {
        this.$message.error('请上传支付凭证信息');
        return;
      }

      const param = {
        "orderId": row.orderId,
        "payImageUrls": row.rowPayOrderImages
      };

      gotoPay(param).then((data) => {
        console.log(JSON.stringify(data))
        this.$message({
          message: data.msg,
          type: 'success'
        });
        this.orderList();
      });
    },

    // todo 以上是处理列表支付和图片中的方法
    /**
     * 处理列表中的支付图片
     * @param row
     * @param index
     */
    handleRowInvoiceRemoveRowPreview(row, index) {
      // 删除预览图片
      this.rowInvoiceOrderFile.splice(index, 1);
      row.rowInvoiceOrderImages.splice(index, 1);
    },

    handleRowInvoiceRemove(file, fileList) {
      // 根据文件的 URL 删除相应的图片
      console.log("fileList" + fileList)
      const index = this.scope.row.rowInvoiceOrderImages.indexOf(file.url);
      if (index !== -1) {
        this.scope.row.rowInvoiceOrderImages.splice(index, 1);
      }
    },

    beforeUpload(file) {
      // 假设我们设置的文件大小限制是2MB
      const MAX_SIZE = 2 * 1024 * 1024;
      if (file.size > MAX_SIZE) {
        this.$message.error('上传图片需要在2MB以内！');
        return false; // 阻止文件上传
      }
      return true; // 允许上传
    },

    handleRowInvoiceSuccess(response, row) {
      // 确保 rowImageUrls 是数组
      if (!row.rowInvoiceOrderImages) {
        this.$set(row, 'rowInvoiceOrderImages', []);
      }
      // 假设后端返回的图片 URL
      if (response) {
        this.$set(row.rowInvoiceOrderImages, row.rowInvoiceOrderImages.length, response.data.fileUrl);  // 强制 Vue 重新渲染
        // row.rowImageUrls.push(response.data.fileUrl); // 将图片 URL 添加到数组中
      }
    },

    /**
     * 去开票
     * @param row
     */
    doInvoice(row) {
      if (row.rowInvoiceOrderImages == undefined || row.rowInvoiceOrderImages <= 0 ) {
        this.$message.error('请上传发票信息')
        return;
      }

      const param = {
        "orderId": row.orderId,
        "payImageUrls": row.rowInvoiceOrderImages
      };

      gotoInvoice(param).then((data) => {
        this.$message({
          message: data.msg,
          type: 'success'
        });
        this.orderList();
      });
    },

    // todo 以上是处理发票中的方法

    // todo 以上是处理列表中的方法

    // todo 以下是处理列表中的方法
    doExamine(row) {
      console.log(JSON.stringify(row));
      this.examineOrderId = row.orderId;
      this.dialogExamineVisible = true;
    },

    doConfirm(row) {
      console.log(JSON.stringify(row));
      confirmOrder(row.orderId).then((data) => {
        if (data.code == 20000) {
          this.dialogVisible2 = false;
          this.$message({
            message: data.msg,
            type: 'success'
          });
          this.orderList();
        } else {
          this.$Message.error(data.msg)
        }
      })
    },

    doCancelConfirm(row) {
      console.log(JSON.stringify(row));
      cancelConfirmOrder(row.orderId).then((data) => {
        if (data.code == 20000) {
          this.dialogVisible2 = false;
          this.$message({
            message: data.msg,
            type: 'success'
          });
          this.orderList();
        } else {
          this.$Message.error(data.msg)
        }
      })
    },

    doDemandPayment(row) {
      console.log(JSON.stringify(row));
      this.orderPayMent.orderId = row.orderId;
      this.orderPayMent.userId = row.userId;
      this.dialogPayMentVisible = true;
    },

    demandPayment() {
      const param = {
        "orderId": this.orderPayMent.orderId,
        "userId": this.orderPayMent.userId
      };
      gotoDemandPayment(param).then((data) => {
        console.log(JSON.stringify(data))
        this.$message({
          message: '催款通知已下发',
          type: 'success'
        });

        // 关闭弹窗
        this.dialogPayMentVisible = false;
      });
    },

    doExamine1() {
      if(this.multipleSelection.length == 0) {
        this.$Message.info("请至少选择一项");
      }else{
        this.dialogExamineVisible1 = true;
      }
    },
    // 重置表单状态
    resetForm() {
      this.approvalStatus = 'approved';
      this.rejectionReason = '';
    },
    // 提交审核
    submitAudit() {
      if (this.approvalStatus === 'rejected' && !this.rejectionReason) {
        this.$message.error('拒绝时必须填写拒绝原因');
        return;
      }

      const param = {
        "orderId": this.examineOrderId,
        "exState": this.approvalStatus,
        "reason": this.rejectionReason
      };

      gotoExamine(param).then((data) => {
        console.log(JSON.stringify(data))
        this.$message({
          message: data.msg,
          type: 'success'
        });
        // 关闭弹窗
        this.orderList();
        this.dialogExamineVisible = false;
      });
    },
    // todo 以上是审核中的方法

    // todo 以上是处理列表中的方法


    handleExpandChange(row, expanded) {
      row.expanded = expanded;  // 控制当前行的商品信息展开状态
    },

    // 打开弹窗
    openDialog(row) {
      this.OrderDetails(row);
      this.orderDetailsVisible = true;
    },

    // 新增一行数据
    addRow() {
      this.OrderDetailsList.push({

      });
    },

    // 保存数据（这里只是一个示例）
    saveData() {
      const productList = [];
      for (let i = 0; i < this.OrderDetailsList.length; i++) {
        const row = this.OrderDetailsList[i];
        if (row.orderCount < row.orderMinNumber) {
          this.$message.error({
            message: "你的产品"+ row.productName +"的购买量不能少于" + row.orderMinNumber + "个",
            duration: 3000,
            top: this.$refs.orderDialog.$el.getBoundingClientRect().top + 50 // 获取弹窗顶部位置并在其下方显示
          });
          return;
        }

        if (row.orderCount > row.orderMaxNumber) {
          this.$message.error({
            message: "你的产品"+ row.productName +"的购买量不能大于" + row.orderMaxNumber + "个",
            duration: 3000,
            top: this.$refs.orderDialog.$el.getBoundingClientRect().top + 50 // 获取弹窗顶部位置并在其下方显示
          });
          return;
        }

        productList.push({
          productId: row.productId,
          orderNumber: row.orderCount,
          addressId: row.addressId
        })
      }

      const param = {
        productDTOS: productList,
      };

      updateOrder(param, "?orderId=" + this.updateOrder).then((data) => {
        console.log(data);
        this.orderDetailsVisible = false; // 关闭弹窗
        this.$Message.success(data.msg);
      })

      this.orderDetailsVisible = false; // 关闭弹窗
    },
    resetTableData() {
      this.orderDetailsVisible = false; // 关闭弹窗
      // this.tableData = [
      //   { name: '张三', age: 25, address: '北京市' },
      //   { name: '李四', age: 30, address: '上海市' }
      // ];
    },

    showForm(show) {
      if (show) {
        this.queryForm.show = false;
        this.showTitle.title = '展开';
        this.showTitle.class = 'el-icon-arrow-down';
      } else {
        this.queryForm.show = true;
        this.showTitle.title = '收起';
        this.showTitle.class = 'el-icon-arrow-up';
      }
    },

    OrderDetails(row) {
      let orderId = row.orderId;
      this.OrderDetailsList = [];
      this.updateOrder = "";
      getOrderDetails(orderId).then((data) => {
        console.log(JSON.stringify(data))
        this.OrderDetailsList = data.data.orderDetails;
        this.updateOrder = data.data.orderId;
        this.cinema = data.data.company;
      })
    },

    orderList() {
      let queryDataForm = this.queryData;
      orderList(queryDataForm).then((data) => {
        this.tableData = data.data.list;
        this.total = data.data.total;
      })
    },

    orderStatistics() {
      let queryDataForm = this.queryData;
      orderStatistics(queryDataForm).then((data) => {
        if (data.data === undefined || data.data === null) {
          document.getElementById('amount').innerHTML = "0";
          document.getElementById('orders').innerHTML = "0";
        }
        console.log("tongjineio.............", data.data.totalAmount)
        this.orderData.amount = data.data.totalAmount;
        this.orderData.orders = data.data.productCount;
        document.getElementById('amount').innerHTML = data.data.totalAmount;
        document.getElementById('orders').innerHTML = data.data.productCount;
      })
    },

    orderDetails(row) {
      console.log("点击的行数据:", row);  // row 即为当前点击的行数据
    },


    onSubmit() {
      console.log(this.queryData.data)
      if (this.queryData.data != "") {
        this.queryData.startTime = moment(String(this.queryData.data[0])).format('YYYY-MM-DD HH:mm:ss');
        this.queryData.endTime = moment(String(this.queryData.data[1])).format('YYYY-MM-DD HH:mm:ss');
      }
      this.queryData.orderName = this.queryData.productName;
      orderList(this.queryData).then((data) => {
        this.tableData = data.data.list;
        this.total = data.data.total;
        for (var i = 0; i < this.tableData.length; i++) {
          this.tableData[i].status = ((data.data.pageNo - 1) * 25 + i + 1)
        }
      });
      if(this.statisticsStatus =='true'){
        this.orderStatistics();
      }
    },
    reset() {
      this.queryData.orderState = null;
      this.queryData.productName = null;
      this.queryData.company = null;
      this.queryData.data = [];
      this.queryData.startTime = null;
      this.queryData.endTime = null;
    },
    dialog(row) {
      this.order.products = row.products;
      this.order.orderId = row.orderId;
      this.order.productNums = row.productNums;
      this.order.addressId = row.addressId;
      this.order.amount = row.amount;
      this.order.expressFee = row.expressFee;
      this.order.printFee = row.printFee;
      this.order.inspectFee = row.inspectFee;
      this.order.packFee = row.packFee;
      this.order.accessoriesFee = row.accessoriesFee;
      this.order.manageFee = row.manageFee;
      this.order.serviceFee = row.serviceFee;
      this.order.orderAmount = row.orderAmount;
      this.order.orderState = row.orderState;
      this.order.productSpecs = row.productSpecs;
      this.order.productName = row.productName;
      getAddress().then((data) => {
        this.order.addressList = data.data.list;
      }),
          this.dialogVisible = true;
    },

    searchAddress() {
      getAddress().then((data) => {
        var addressList = data.data.list;
        addressList.forEach(address => {
          this.addressOptions.push({"value": address.id, "label": address.address});
          this.userAddressList.push({"id": address.id, "value": address}) // 相对与页面暂存，存到详情表中
        })
      })
    },

    handleSelectChange(row, newValue) {
      this.userAddressList.forEach(address => {
        if (address.id === newValue) {
          row.addressName = address.value.nikeName;
          row.addressPhone = address.value.phone;
        }
      })
      console.log('当前行的数据:', row);
    },

    update(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          console.log(this.order);
          updateOrder(this.order, this.order.orderId).then((data) => {
            console.log(data);
            this.dialogVisible = false;
            this.$Message.info(data.msg);
            if (data.data == true) {
              this.orderList();
            }
          })
        } else {
          this.$Message.error('请输入产品数量和用户地址!');
        }
      })
    },

    remove(orderId) {
      this.orderId = orderId;
      this.dialogVisible2 = true;
    },

    delete1(){
      deleteOrder(this.orderId).then((data) => {
        if (data.code == 20000) {
          this.dialogVisible2 = false;
          this.$message({
            message: data.msg,
            type: 'success'
          });
          this.orderList();
        } else {
          this.$Message.error(data.msg)
        }
      })
    },
    updateStatusOrder(orderId,type,orderState) {
      this.orderId = orderId;
      this.orderState = orderState;
      if(type==1){
        this.dialogTitle="审核";
        this.dialogVisible1 = true;
        // document.getElementById('content').innerHTML = "请确认是否审核该订单？";
        // console.log(document.getElementById('content').innerHTML)
      }else{
        this.dialogTitle="确认收款";
        this.dialogVisible3 = true;
        // document.getElementById('content').innerHTML = "请确认是否收款？"
      }
    },
    updateStatus(){
      updateStatusOrder(this.orderId,this.orderState).then((data) => {
        if (data.code == 20000) {
          this.dialogVisible1 = false;
          this.dialogVisible3 = false;
          this.$Message.success(data.msg)
          this.orderList();
        } else {
          this.$Message.error(data.msg)
        }
      })
    },

    exportAllOrder() {
      axios.post('/movie/v2/order/export/all', this.queryData, {
        responseType: 'blob', // 重要！告诉 axios 服务器返回的是文件流
      }).then(res =>{
        if(res.status == 200) {
          // 创建 Blob 对象并触发下载
          const blob = new Blob([res.data], {type: 'application/vnd.ms-excel'});
          // 创建下载链接
          const link = document.createElement('a');
          link.href = URL.createObjectURL(blob);
          link.download = '订单信息.xls'; // 设置下载文件的名字

          // 触发点击事件，开始下载
          link.click();
          // 释放 Blob 对象
          URL.revokeObjectURL(link.href);
        }
      });
    },

    exportOrder() {
      // const response =
      axios.post('/movie/v2/order/export', this.queryData, {
        responseType: 'blob', // 重要！告诉 axios 服务器返回的是文件流
      }).then(res =>{
        if(res.status == 200) {
          // 创建 Blob 对象并触发下载
          const blob = new Blob([res.data], {type: 'application/vnd.ms-excel'});
          // 创建下载链接
          const link = document.createElement('a');
          link.href = URL.createObjectURL(blob);
          link.download = '待生产信息.xls'; // 设置下载文件的名字

          // 触发点击事件，开始下载
          link.click();
          // 释放 Blob 对象
          URL.revokeObjectURL(link.href);
        }
      });

      // if (queryDataForm.orderState != null) {
      //   params = "?orderState=" + queryDataForm.orderState
      // }
      // if (queryDataForm.productName != null) {
      //   if (params != "") {
      //     params += "&"
      //   } else {
      //     params = "?"
      //   }
      //   params += "productName=" + queryDataForm.productName
      // }
      // console.log(params);
      // var url = path("/v2/order/export" + params);
      // window.open(url, '_blank')
    },

    exportOrderInvoice() {
      axios.post('/movie/v2/order/export/invoice', this.queryData, {
        responseType: 'blob', // 重要！告诉 axios 服务器返回的是文件流
      }).then(res => {
        if (res.status == 200) {
          // 创建 Blob 对象并触发下载
          const blob = new Blob([res.data], {type: 'application/vnd.ms-excel'});
          // 创建下载链接
          const link = document.createElement('a');
          link.href = URL.createObjectURL(blob);
          link.download = '已支付待开票信息.xls'; // 设置下载文件的名字
          // 触发点击事件，开始下载
          link.click();
          // 释放 Blob 对象
          URL.revokeObjectURL(link.href);
        }
      });
    },

    handleSizeChange(a) {
      this.queryData.size = a;
      this.orderList()
    },
    changePage(page) {
      this.queryData.pageNo = page;
      this.orderList()
    },
    statistics() {
      if (this.queryData.data != "") {
        this.queryData.startTime = this.queryData.data[0];
        this.queryData.endTime = this.queryData.data[1];
      }
      let data = {
        "startTime": this.queryData.startTime,
        "endTime": this.queryData.endTime,
        "productName": this.queryData.productName,
        "company": this.queryData.company,
        "orderState": this.queryData.orderState
      };
      console.log(data)
      var url = '/movie/v2/order/statistics';
      axios.post(url, data).then((response) => {
        console.log("数据为" + response.data.data);
        if (response.data.code == 20000) {
          this.orderData.amount = response.data.data.amount;
          this.orderData.orders = response.data.data.orders;
          document.getElementById('amount').innerHTML = response.data.data.amount;
          document.getElementById('orders').innerHTML = response.data.data.orders;
        } else {
          this.$Message.error(response.statusText);
        }

      })
    },
    selectionChange(val) {
      this.multipleSelection = val;
      console.log(this.multipleSelection);
    },
    batchChange() {
      if (this.multipleSelection.length == 0) {
        this.$Message.info("请至少选择一项");
      } else {
        var orderIds = [];
        this.multipleSelection.forEach((element) => {
          this.tableData.forEach((e) => {
            if (element.orderId == e.orderId) {
              orderIds.push(e.orderId)
            }
          })
        })
        if (this.approvalStatus === 'rejected' && !this.rejectionReason) {
          this.$message.error('拒绝时必须填写拒绝原因');
          return;
        }

        const param = {
          "orderIds": orderIds,
          "exState": this.approvalStatus,
          "reason": this.rejectionReason
        };
        batchChange(param).then((data) => {
          if (data.code == 20000) {
            this.multipleSelection = [];
            this.$Message.success(data.msg)
            this.orderList();
          } else {
            this.$Message.error(data.msg)
          }
          this.dialogExamineVisible1 = false;
        })
      }
    },
    selectable: function (row, index) {
      console.log(row + "," + index)
      if ((this.userType == 2 || this.userType == 4) && row.orderState == 100) {
        return true;
      } else {
        return false;
      }
    },


  },

  created() {
    this.searchAddress();
    this.orderList();
    if (this.statisticsStatus == "true") {
      this.orderStatistics();
    }
  }
}
</script>

<style scoped>
.bottom {
  margin-top: 10px;
  padding-bottom: 25px;
}

.el-divider--horizontal {
  display: block;
  height: 1px;
  width: 100%;
  margin: 10px 0;
}

.table {
  background: #FFF;
  padding: 15px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  height: auto;
}

.top {
  margin-bottom: 10px;
}

.top-query {
}

.show-form {
  font-size: 10px;
  margin-left: 8px;
}

.el-icon-arrow-down {
  display: inline-block;
}

.button-del {
  background-color: red;
  color: white;
  border: none;
  right: 5px;
  padding: 5px 10px;
  cursor: pointer;
}

.line {
  border: 1px solid #cecaca;
  margin-top: -3%;
  margin-bottom: 3%;
}

.line1 {
  border: 1px solid #cecaca;
  margin-top: 3%;
  margin-bottom: -2%;
}

/* 控制PDF预览组件的尺寸 */
.thumbnail {
  cursor: pointer;
  display: inline-block;
  margin: 10px;
  border: 1px solid #ddd;
}

.pdf-preview-container {
  text-align: center;
  padding: 20px;
}
</style>
